module.exports = __webpack_public_path__ + "img/pengbo.6d182a6d.jpg";